module.exports = __webpack_public_path__ + "static/fonts/Nunito-Medium.f95d44d.woff";